import { render, staticRenderFns } from "./SavedFilters.vue?vue&type=template&id=2581f158&scoped=true"
import script from "./SavedFilters.vue?vue&type=script&lang=ts"
export * from "./SavedFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2581f158",
  null
  
)

export default component.exports